import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./EditBanner.css";
import { getBannerById, updateBannerApi } from "../../../services/Banner/Banner.service";
import { toast } from "react-toastify";

const EditBanner: React.FC = () => {
  const { banner_id } = useParams<{ banner_id: string }>();
  const navigate = useNavigate();

  const [bannerName, setBannerName] = useState("");
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [preview, setPreview] = useState<string | null>(null);
  const [status, setStatus] = useState("active");
  const [loading, setLoading] = useState(true);

  const fileInputRef = useRef<HTMLInputElement>(null);

  // 🔹 Fetch banner by ID
  useEffect(() => {
    const fetchBanner = async () => {
      if (!banner_id) return;
      try {
        const data = await getBannerById(Number(banner_id));
        setBannerName(data.banner_name);
        setPreview(data.banner_image || null);
        setStatus(data.status?.toLowerCase() || "active");
      } catch (error) {
        toast.error("Failed to load banner");
      } finally {
        setLoading(false);
      }
    };
    fetchBanner();
  }, [banner_id]);

  // 🔹 Image change
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setImageFile(file);
    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result as string);
    reader.readAsDataURL(file);
  };

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  // 🔹 Submit
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!bannerName.trim()) {
      toast.error("Banner name is required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("banner_name", bannerName);
      formData.append("status", status.toUpperCase());
      if (imageFile) formData.append("banner_image", imageFile);

      await updateBannerApi(Number(banner_id), formData);
      toast.success("Banner updated successfully 🎉");
      navigate("/banner/list");
    } catch (error) {
      toast.error("Failed to update banner");
    }
  };

  if (loading) return <div className="loader">Loading...</div>;

  return (
    <div className="add-category-container">
      <h2>Edit Banner</h2>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={bannerName}
          onChange={(e) => setBannerName(e.target.value)}
          placeholder="Banner Name"
        />

        {/* Image Upload */}
        <div className="image-upload-box" onClick={openFilePicker}>
          {preview ? (
            <img src={preview} alt="Preview" className="preview-image" />
          ) : (
            <span>Click to upload image</span>
          )}
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: "none" }}
        />

        <div className="button-close">
          <button type="button" onClick={() => navigate("/banner/list")}>Close</button>
        <button type="submit">Update</button>
        </div>
      </form>
    </div>
  );
};

export default EditBanner;
